import {
  HexIcon,
  Icons,
  ExternalLink,
  Typography,
  Box,
  Stack,
  colorOrToken,
  tokens,
} from '@cast/design-system';

import { getDocsLink } from '@cast/utils';

import { EXTERNAL_LINKS } from '@cast/constants';

export type ErrorStateProps = {
  title: string;
  testId?: string;
};

export const ErrorState = ({ title, testId }: ErrorStateProps) => {
  return (
    <Stack
      display="grid"
      columnGap={12}
      rowGap={4}
      gridTemplateColumns="auto 1fr"
      gridTemplateAreas={`
        "icon title"
        "empty content"
      `}
      alignItems="center"
      data-testid={testId}
    >
      <HexIcon
        variant="error"
        display="flex"
        gridArea="icon"
        size={44}
        animationType="pulsateSlow"
        icon={<Icons.Warning />}
      />
      <Typography gridArea="title" variant="h6">
        {title}
      </Typography>
      <Box
        gridArea="content"
        component="ul"
        sx={{
          pl: 18,
          my: 0,
          '& li': {
            typography: 'P12R',
            color: colorOrToken(
              'grey.500',
              tokens.theme.fg.structural.secondary
            ),
          },
        }}
      >
        <li>Double-check if you ran the script correctly</li>
        <li>
          Check our{' '}
          <ExternalLink
            sx={{ typography: 'P12M' }}
            link={getDocsLink('docs')}
            noIcon
          >
            documentation
          </ExternalLink>
        </li>
        <li>
          Ask a question on our{' '}
          <ExternalLink
            sx={{ typography: 'P12M' }}
            link={EXTERNAL_LINKS.castai_slack_community}
            noIcon
          >
            Community Slack
          </ExternalLink>
        </li>
        <li>
          Try using{' '}
          <ExternalLink
            sx={{ typography: 'P12M' }}
            link={EXTERNAL_LINKS.castai_terraform}
            noIcon
          >
            Terraform
          </ExternalLink>
        </li>
      </Box>
    </Stack>
  );
};
